<template>
  <div class="promotion-dialog">
    <div class="promo-container" :class="$i18n.locale === 'nl' ? 'set-container-size' : ''">
      <div class="image-wrapper">
        <img v-if="scrollDirection === 'vertical'" class="promo-image" src="@/assets/images/promo-image-mob.png" alt="promo-image" />
        <img v-else class="promo-image" src="@/assets/images/promo-image-desktop.png" alt="promo-image" />
      </div>
      <div class="close" @click="onClose">
        <img src="@/assets/images/subscription-close-modal.svg" alt="close-button">
      </div>
      <div class="promo-content" :class="$i18n.locale === 'ar' ? 'set-rtl-content-direction' : ''">
        <div class="title" :class="$i18n.locale === 'ar' ? 'set-rtl-direction' : ''">
          {{ $t('holiday_begin2') }}
        </div>
        <div class="main-title" :class="$i18n.locale === 'ar' ? 'set-rtl-direction' : $i18n.locale === 'nl' ? 'set-font-size' : ''">
          {{ $t('christmas_modal_title') }}
        </div>
        <div class="justify-action-content" :class="$i18n.locale === 'ar' ? 'set-rtl-direction' : ''">
          <div class="info">
            {{ $t('promo_code_label') }} :
            <span class="promo-code"> {{ getPromoCode }}</span>
          </div>
          <SubmitButton class="set-width-portrait" :label="$t('get_started_button')" :isLoading="false" @click="goToAccount('register')"/>
        </div>
        <div class="promo-footer" :class="$i18n.locale === 'ar' ? 'set-rtl-direction' : ''">
          {{ $t('payment_will_be_charged') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { component } from 'vue/types/umd';
import SubmitButton from '../components/SubmitButton.vue';
export default {
    name: 'PromotionalDialog',
    props: {
        close: {
            type: Function,
            default: () => {}
        }
    },
    components: {
			"SubmitButton": SubmitButton
    },
    computed: {
      getPromoCode() {
        return this.$i18n.locale === 'fr' ? 'NOEL25' : 'XMAS25';
      }
    },
    data () {
        return {
            scrollDirection: 'horizontal'
        };
    },
    mounted () {
        this.updateDirection();
        window.addEventListener('resize', this.updateDirection);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.updateDirection);
    },
    methods: {
        updateDirection () {
            this.scrollDirection = window.innerWidth < window.innerHeight ? 'vertical' : 'horizontal';
        },
        onClose () {
            this.close();
        },
        goToAccount (path) {
          this.close();
          this.$router.push({name: 'register'}).catch(()=>{});
        }
    }
};
</script>
<style lang="scss" scoped>
.set-rtl-direction {
  text-align: right !important;
  direction: rtl;
}
.set-rtl-content-direction {
  justify-content: right !important;
  align-items: flex-end !important;
  text-align: right !important;
}
.set-font-size {
  font-size: inherit;
}
@media (orientation: portrait) and (max-width: 400px) {
  .set-font-size {
    font-size: 10px !important;
  }
  .set-container-size {
    width: 95%;
    max-width: 95%;
    height: 97dvh !important;
    max-height: 97dvh !important;
  }
}

</style>